export default [
    {
        path: '/eventCategories',
        name: 'eventCategories',
        component: () => import ('./pages/Index')
    },
]